import { MinimizedModalsContext } from '../context'
import { useMinimizedModals } from '../hooks'

function MinimizedModalsProvider({ children }) {
  const value = useMinimizedModals()

  return (
    <MinimizedModalsContext value={value}>{children}</MinimizedModalsContext>
  )
}

export default MinimizedModalsProvider
